import { render, staticRenderFns } from "./page_search.vue?vue&type=template&id=7181db11&scoped=true&"
import script from "./page_search.vue?vue&type=script&lang=js&"
export * from "./page_search.vue?vue&type=script&lang=js&"
import style0 from "./page_search.vue?vue&type=style&index=0&id=7181db11&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7181db11",
  null
  
)

export default component.exports